import React, {useEffect, useState} from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import {useTranslation} from "react-i18next";
import {connect, setStore} from "trim-redux";
import {Typography} from "@mui/material";
import {getDisplayTime} from "../../../../../config/values";
import VendorOrderTime from "../../../front/shops/components/VendorOrderTime";


function ViewDeliveryTime({classes,selected_time,timing,shop}){
    const { t } = useTranslation();
    const [selectedTime, setSelectedTime] = useState(null);


    return (
        <div className="delivery-wide flex-column-md">
            <div className="flex-direction mb-md-5 space-between-md">
            {
                !!selected_time ?
                    <Typography>{getDisplayTime(selected_time)}</Typography> :
                    <Typography>{t('now')}</Typography>

            }
                {
                    !!shop?.delivery_time &&
                    <Typography class="time">{t('until')} {shop?.delivery_time} {t('min')}</Typography>
                }

            </div>
            <VendorOrderTime
                timing={timing}
                setTime={(time) => setSelectedTime(time)}
                edit
            />
        </div>

    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
    selected_time: state.selected_time,
});

export default withStyles(Styles)(connect(mapStateToProps)(ViewDeliveryTime));
